module.exports = __webpack_public_path__ + "img/Kart_1_350x350.jpg";